<template>
    <div class="map-component">
        <map-slider-component
            class="map-component--slider"
            :selectedMilePrefill="preselectedMilePrefill"
            @distance-changed="distanceChanged"
        ></map-slider-component>
        <l-map ref="mapRef" :zoom="zoom">
            <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
            <l-marker-cluster>
                <l-marker v-for="(marker, index) in markers" :key="index" :latLng="[marker.latitude, marker.longitude]">
                    <l-icon :iconUrl="customMarker"></l-icon>
                    <l-popup :id="getMarkerPracticeId(marker)" class="map-component__popup">
                        <map-tooltip-component :markerData="marker"></map-tooltip-component>
                    </l-popup>
                </l-marker>
            </l-marker-cluster>
        </l-map>
    </div>
</template>

<script>
    import { LMap, LTileLayer, LMarker, LIcon, LPopup } from 'vue2-leaflet'
    import 'leaflet/dist/images/marker-icon.png'
    import 'leaflet/dist/images/marker-shadow.png'
    import 'leaflet/dist/leaflet.css'
    import 'leaflet.markercluster/dist/MarkerCluster.css'
    import 'leaflet.markercluster/dist/MarkerCluster.Default.css'
    import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'
    import MapSliderComponent from 'components/page-elements/map/MapSliderComponent'
    import MapTooltipComponent from 'components/page-elements/map/MapTooltipComponent'
    import L from 'leaflet'
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'

    export default {
        components: {
            LMap,
            LTileLayer,
            LMarkerCluster: Vue2LeafletMarkerCluster,
            LMarker,
            MapSliderComponent,
            MapTooltipComponent,
            LIcon,
            LPopup,
        },
        props: {
            markers: { type: Array, default: () => [] },
            preselectedMilePrefill: { type: Number, default: 20 },
        },

        data() {
            return {
                url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
                zoom: 9,
                currentLocation: null,
            }
        },

        computed: {
            customMarker() {
                return require('../../../images/icon-map-blue.svg').default
            },

            currentLocationMarkerIcon() {
                return require('../../../images/icon-current-location.svg').default
            },
        },

        methods: {
            distanceChanged(payload) {
                this.emitEvent({ name: 'distance-changed', payload })
            },

            getMarkerPracticeId(marker) {
                if (marker.item?.practice?.practceType === PracticeTypeEnum.PHYSICIAN) {
                    return marker.item?.practice?.id
                } else {
                    return marker.item?.id
                }
            },

            getCurrentLocation() {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition((position) => {
                        const lat = position.coords.latitude
                        const lng = position.coords.longitude
                        this.currentLocation = {
                            lat: lat,
                            lng: lng,
                        }
                    })
                }
            },

            positionOnTheMap() {
                const coordinates = this.markers.map((marker) => [marker.latitude, marker.longitude])
                const markerLatLngs = coordinates
                const bounds = L.latLngBounds(markerLatLngs)
                this.$refs.mapRef.mapObject.fitBounds(bounds)
            },
        },

        watch: {
            markers() {
                this.positionOnTheMap()
                const self = this
                this.$refs.mapRef.mapObject.on('popupopen', function (e) {
                    self.emitEvent({ name: 'popup-open', payload: e.popup?._content.id })
                })
                this.$refs.mapRef.mapObject.on('popupclose', function () {
                    self.emitEvent({ name: 'popup-close' })
                })
            },
        },

        mounted() {
            this.positionOnTheMap()
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';
    .map-component {
        width: 100%;
        height: 500px;
        border: 1px solid $color--accent-5;
        background: $color-white;
        border-radius: 0.375rem;
        padding-top: 20px;

        &--slider {
            margin-bottom: 40px;
        }
    }
</style>
